var map = {
	"./bbc.png": "45d3",
	"./btc.png": "cdcb",
	"./bxc.png": "f097",
	"./eth.png": "46f6",
	"./exc.png": "72c6",
	"./rsvc.png": "d749",
	"./usdt.png": "fa09",
	"./xrp.png": "e405"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a04a";